import settings from '@/settings'
import { getAuthenticationActionUrl, getPersonalUrl } from '@/helpers'

const COMMON_MENU_CHECK_INTERVAL = 500
const MAX_CHECK_CYCLES = 10
const LOADER_SCRIPT_ID = 'common_menu_loader'

const waitForCommonMenu = () => new Promise((resolve, reject) => {
  let counter

  if (window.GS && window.GS.CommonMenu) {
    return resolve(window.GS.CommonMenu)
  }

  const interval = setInterval(() => {
    if (window.GS && window.GS.CommonMenu) {
      clearInterval(interval)

      return resolve(window.GS.CommonMenu)
    }

    if (++counter > MAX_CHECK_CYCLES) {
      clearInterval(interval)

      return reject(MAX_CHECK_CYCLES)
    }
  }, COMMON_MENU_CHECK_INTERVAL)
})

const getHandler = urlActionPart => event => {
  const redirectUrl = getAuthenticationActionUrl(urlActionPart)

  event.preventDefault()
  location.assign(redirectUrl)
}

const setLoginHandler = commonMenu => commonMenu.on('login', getHandler('signin'))
const setLogoutHandler = commonMenu => commonMenu.on('logout', getHandler('signout/trigger'))
const setRegisterHandler = commonMenu => commonMenu.on('registration', getHandler('registration'))

const initHolder = commonMenu => commonMenu.trigger('holder_ready')

/**
 * Common Menu initialization
 */
export function createCommonMenuLoader () {
  const script = document.createElement('script')
  const redirectUrl = getAuthenticationActionUrl('signin')
  const personalUrl = getPersonalUrl()
  script.id = LOADER_SCRIPT_ID
  script.src = `//${settings.CM_FRONTEND_URL}/loader.min.js`
  script.async = true

  script.dataset.service = process.env.VUE_APP_CM_SERVICE
  script.dataset.project = process.env.VUE_APP_CM_PROJECT
  script.dataset.realm = process.env.VUE_APP_CM_REALM
  script.dataset.language = process.env.VUE_APP_CM_LANGUAGE
  script.dataset.login_url = redirectUrl
  script.dataset.backend_url = `//${settings.CM_BACKEND_URL}`
  script.dataset.incomplete_profile_url = settings.CM_INCOMPLETE_PROFILE_URL
  script.dataset.ssw_enabled = true
  script.dataset.ssw_client_id = settings.SSW_CLIENT_ID
  script.dataset.incomplete_profile_url = personalUrl

  document.body.appendChild(script)
}

/**
 * Common Menu initialization
 */
export async function initCommonMenu () {
  const commonMenu = await waitForCommonMenu()

  initHolder(commonMenu)
  setLoginHandler(commonMenu)
  setLogoutHandler(commonMenu)
  setRegisterHandler(commonMenu)

  // Force rerender commonmenu after component <CommonMenu /> has been reinjected using router
  if (!document.querySelector('#common_menu').childNodes.length) {
    let updates = commonMenu.getOptions()
    commonMenu.update({ cbp_force_updates: updates.cbp_force_updates === undefined ? 0 : updates.cbp_force_updates++ })
  }
}
